<template>
  <header class="app-header">
    <div class="app-header-placeholder"></div>

    <div class="app-header-body" :class="{ white: isWhite }" :style="headerStyle">
      <!-- <img v-if="icon && showBack" class="icon" :src="icon" @click="onBack" /> -->
      <img
        v-if="showBack"
        class="icon"
        :src="
          isWhite
            ? 'https://parmatch-prod-1312453921.cos.ap-guangzhou.myqcloud.com/static/icons/back-black-icon.png'
            : 'https://parmatch-prod-1312453921.cos.ap-guangzhou.myqcloud.com/static/icons/back-white-icon.png'
        "
        @click="onBack"
      />
      <span class="name" :class="{ 'black-text': isWhite }">{{ title }}</span>
      <div class="icon"></div>
    </div>
  </header>
</template>
<script setup lang="ts">
import { useRouter, useRoute, RouterLink } from 'vue-router'
import { computed } from 'vue'

const router = useRouter()
const route = useRoute()
const emit = defineEmits(['back'])

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  isWhite: {
    type: Boolean,
    default: false,
  },
  opacity: {
    type: Number,
    default: 1,
  },
  icon: {
    type: String,
    default: '',
  },
  showBack: {
    type: Boolean,
    default: true,
  },
})

const headerStyle = computed(() => {
  return {
    backgroundColor: props.isWhite ? `rgba(255, 255, 255, ${props.opacity})` : '#ff5e8e',
  }
})

const onBack = () => {
  emit('back')
}
</script>
<style lang="scss" scoped>
.app-header {
  width: 100%;
  .app-header-placeholder {
    width: 100%;
    height: 130px;
    overflow: hidden;
    opacity: 0;
  }

  .app-header-body {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    width: 100%;
    height: 130px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    z-index: 999;
    transition: all 0.3s ease;

    .icon-btn {
      width: 48px;
      height: 48px;
      border: none;
      outline: none;
      background-color: transparent;
    }

    .icon {
      width: 48px;
      height: 48px;
      transition: all 0.3s ease;
    }

    .name {
      flex: 1;
      color: #fff;
      text-align: center;
      font-family: 'PingFang SC';
      font-size: 38px;
      font-weight: 600;
      line-height: 130px;
      transition: color 0.3s ease;

      &.black-text {
        color: #333;
      }
    }

    .blank {
      flex: 1;
    }

    &.white {
      background-color: #ffffff;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    }
  }
}
</style>
